import React from 'react';
import propTypes from 'prop-types';
import mergeI18n from '../../lib/util/merge-i18n';
import i18n from './i18n';

class TermsOfServiceContainer extends React.Component {
	render () {
		const __ = mergeI18n(this.props.language, i18n);
		document.title = `${__.titleStem} - ${__.pageTitle}`;

		return (
			<div id='lss-content'>
				<div id='terms-of-service' className='row'>
					<div className='col-sm-12 col-md-6 col-md-offset-3'>
						<div className='row'>
							<div className='col-xs-12'>
								<h1>{__.pageTitle}</h1>
								<h2>{__.pageSubTitle}</h2>
								<p className='language'><span>{__.languageName}</span></p>

								<time><i>{__.updated}</i></time>

								<p>{__.description}</p>

								<ol>
									<li>{__.aim.title}
										<p>{__.aim.description}</p>
									</li>

									<li>{__.accuracyOfInformation.title}
										<p>{__.accuracyOfInformation.description()}</p>
									</li>

									<li>{__.fairnessAndCourtesy.title}
										<p>{__.fairnessAndCourtesy.description}</p>
									</li>

									<li>{__.disclaimersAndIndemnification.title}
										<p>{__.disclaimersAndIndemnification.description}</p>
										<ol>
											<li>{__.disclaimersAndIndemnification.ol.a()}</li>
											<li>{__.disclaimersAndIndemnification.ol.b}</li>
											<li>{__.disclaimersAndIndemnification.ol.c}</li>
											<li>{__.disclaimersAndIndemnification.ol.d}</li>
										</ol>
									</li>

									<li>{__.arbitrationRules.title}
										<p>{__.arbitrationRules.description}</p>
										<ol>
											<li>{__.arbitrationRules.ol.a()}</li>
											<li>{__.arbitrationRules.ol.b()}</li>
											<li>{__.arbitrationRules.ol.c()}</li>
											<li>{__.arbitrationRules.ol.d()}</li>
											<li>{__.arbitrationRules.ol.e()}</li>
										</ol>
									</li>

									<li>{__.electronicSignatures.title}
										<p>{__.electronicSignatures.description}</p>
									</li>

									<li>{__.boundByRepresentatives.title}
										<p>{__.boundByRepresentatives.description}</p>
									</li>

									<li>{__.noRightToDoBusiness.title}
										<p>{__.noRightToDoBusiness.description}</p>
									</li>

									<li>{__.proprietaryRights.title}
										<p>{__.proprietaryRights.description}</p>
									</li>

									<li>{__.limitationsOfLiability.title}
										<p>{__.limitationsOfLiability.description()}</p>
									</li>

									<li>{__.refundCancellationPolicy.title}
										<p>{__.refundCancellationPolicy.description}</p>
									</li>

									<li>{__.choiceOfLawAndConsentToJurisdiction.title}
										<p>{__.choiceOfLawAndConsentToJurisdiction.description}</p>
									</li>

									<li>{__.understandingOfTermsAndConditions.title}
										<p>{__.understandingOfTermsAndConditions.description}</p>
									</li>

									<li>{__.severability.title}
										<p>{__.severability.description}</p>
									</li>

									<li>{__.electronicApproval.title}
										<p>{__.electronicApproval.description}</p>
									</li>

									<li>{__.privacyPolicy.title}
										<p>{__.privacyPolicy.description()}</p>
									</li>
								</ol>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

TermsOfServiceContainer.propTypes = {
	language: propTypes.string.isRequired
};
export default TermsOfServiceContainer;
